import { render, staticRenderFns } from "./SessionWarningModal.vue?vue&type=template&id=31eb54ea&scoped=true&"
import script from "./SessionWarningModal.vue?vue&type=script&lang=js&"
export * from "./SessionWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./SessionWarningModal.vue?vue&type=style&index=0&id=31eb54ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../PatientEnrollment/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eb54ea",
  null
  
)

export default component.exports